const footerEn = {
    "follow_us": "Follow us!",
    "all_rights_reserved": "2024 Code Kitchen Kft all right reserved",
    "terms_and_conditions": "Terms and Conditions",
    "privacy_policy": "Privacy Policy",
}

export default footerEn;